import React from "react";
import { NoResultContainer, StyledH1, Hal, Wraps } from "./styled";
import forOfor from "../../../components/Assets/budowlaniec.png";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  fetchData,
  selectIsLoading} from "../../../../mainApp/features/DataSlice/dataSlice";
  import LoadingPage from "../LoadingPage";
import ErrorPage from "../ErrorPage";
  



function UnderConstruction() {

  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);

  let returned = "";
  useEffect(() => {
    dispatch(fetchData());
  }, []);

    switch (isLoading) {
      case "loading":
        returned = <LoadingPage />;
        break;
      case "success":
        returned = (
    <Wraps>
      <StyledH1>Ooops</StyledH1>
      <Hal src={forOfor} alt="HAL 9000 is alive" />
      <NoResultContainer>
        <StyledH1>Strona w budowie<br/>
        Wróć później!</StyledH1>
      </NoResultContainer>
    </Wraps>   );
      break;
    case "error":
      returned = <ErrorPage />;
      break;
    default:
      returned = <LoadingPage />;
  }

  return returned;
  
}

export default UnderConstruction;
